export default "__VITE_ASSET__C0Uh5ayz__"